<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('modeSwitchingRecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="formInline.ouName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              :popper-append-to-body="false"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"
            >
              <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('userNameH')">
            <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mode')">
            <el-select v-model="formInline.mode" clearable :placeholder="$t('mode')" :popper-append-to-body="false">
              <el-option v-for="item of fileType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP')">
            <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('startDate')" class="datetime">
            <el-date-picker
              v-model="formInline.logTimestampBegin"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.logTimestampEnd"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button
              type="primary"
              class="serachBtn letter_delet"
              @click="handleDelet"
              v-preventReClick="1000"
              v-has="'sys:new:setting:log:data:delete'"
              >{{ $t('batchDelete') }}</el-button
            >
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- table 表格 -->

      <div class="table-box">
        <Table
        v-loading="loading"
          :data="tableData"
          :columns="columns"
          :operation="dateOperation"
          :type="type"
          @getList="getList"
          @operate="operationEvent"
          :currentPage="currentPage"
          :pageSize="pageSize"
          ref="tanleAssembly"
          :operationWidth="100"
          @sortChange="handleSort"
        ></Table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// 引入table组件
import Table from '@/components/NewTable'
import { switchPage, switchDelete } from '@/api/log/logSwitch'
import { getOus } from '@/api/UserList'
import { getExportSwitch } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  data() {
    return {
      ouList: [],
      // 表单查询字段
      formInline: {
        ouName: '',
        ouId: '',
        helmetId: '',
        userName: '',
        logTimestampBegin: beforeWeekDate(),
        logTimestampEnd: nowDate(),
        mode: '',
      },
      // 当前页
      currentPage: 1,
      // 当前 条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      // 查询 ‘模式’的类型
      fileType: [
        { value: '0', label: this.$t('performance') },
        { value: '1', label: this.$t('standard') },
        { value: '2 ', label: this.$t('power') },
        { value: '3', label: this.$t('privacy') },
      ],
      // 用于批量删除 公共组件类型判断
      type: 'ModeSwitching',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logTimestampBegin: this.formInline.logTimestampBegin,
        logTimestampEnd: this.formInline.logTimestampEnd,
        userName: this.formInline.userName,
        mode: this.formInline.mode,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportSwitch(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('modeSwitchingRecord') + '.xls')
      })
    },
    // 排序
    handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc = data.order === 'descending' ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this.deleteMediaUpload(row)
      }
    },
    // 删除媒体上传日志
    deleteMediaUpload(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          id: row.value.id,
        }
        switchDelete(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.logTimestampBegin, this.formInline.logTimestampEnd)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    // 基础配置数据
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logTimestampBegin: this.formInline.logTimestampBegin,
        logTimestampEnd: this.formInline.logTimestampEnd,
        userName: this.formInline.userName,
        mode: this.formInline.mode,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      switchPage(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.tableData.map(item => {
            if (item.mode === 3) {
              item.modeStr = this.$t('privacy')
            } else if (item.mode === 2) {
              item.modeStr = this.$t('power')
            } else if (item.mode === 1) {
              item.modeStr = this.$t('standard')
            } else if (item.mode === 0) {
              item.modeStr = this.$t('performance')
            }
          })
          this.totalData = res.value.total
        }
      })
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'modeStr',
          label: this.$t('mode'),
          align: 'center',
          width: '100',
          sort: 'mode',
        },
        {
          attrName: 'uploadTimestamp',
          label: this.$t('Recordtime'),
          align: 'center',
          width: '180',
          sort: 'uploadTimestamp',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
  },
  created() {
    this.basicConfig()
  },
  mounted() {
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';

>>>.el-table {
  height: 640px !important;
  min-height: 500px !important; /* no */
  overflow: auto;
}

>>>.el-popper {
  min-width: 100% !important;
}
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)

.letter_delet {
  margin-left: 10px;
}

.bg-contain .common-table-cnt /deep/ .el-table {
  height: 624px !important;
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}
</style>
